import { MaxMfaAttemptsReachedErrorCodes, MFA_ERROR_CODES } from '../constants';

/**
 * @description determines whether an MFA verification challenge failure should result in preventing the user
 * from making additional attempts.
 * @param {MFA_ERROR_CODE|null} errorCode
 * @returns {boolean}
 */
export const cannotAttemptAuthenticateChallenge = (errorCode) => {
    return (
        MaxMfaAttemptsReachedErrorCodes.has(errorCode) ||
        errorCode === MFA_ERROR_CODES.CodeChallengeExpired
    );
};
